import { render, staticRenderFns } from "./LoadOnVisible.vue?vue&type=template&id=36f26fd1"
import script from "./LoadOnVisible.vue?vue&type=script&lang=js"
export * from "./LoadOnVisible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports